import { render, staticRenderFns } from "./ModificarGeneracion.vue?vue&type=template&id=3aa72e81"
import script from "./ModificarGeneracion.vue?vue&type=script&lang=js"
export * from "./ModificarGeneracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports